import React, { useState } from 'react';
import { ArrowRight, QrCode, Check, Copy } from 'lucide-react';
import { AppBuilderQRCodeDisplayProps } from '../types/appbuilder';
import { noAutofill } from '../noAutofill';

const AppBuilderQRCodeDisplay: React.FC<AppBuilderQRCodeDisplayProps> = ({
  url,
  qrCode,
  projectName,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="ed-final ed-final--split">
      <div className="ed-qr">
        <div className="ed-qr-frame">
          {qrCode ? (
            <img src={qrCode} alt={`QR code linking to ${projectName}`} />
          ) : (
            <div className="ed-qr-placeholder">
              <QrCode size={40} opacity={0.4} />
              <span className="ed-meta">Generating…</span>
            </div>
          )}
        </div>
        <span className="ed-meta">Scan to open it on your phone</span>
      </div>

      <div className="ed-final-body">
        <span className="ed-badge">Deployed</span>

        <div className="ed-spec">
          <div className="ed-spec-row">
            <span className="ed-spec-key">Application</span>
            <span className="ed-spec-val">{projectName}</span>
          </div>
          <div className="ed-spec-row">
            <span className="ed-spec-key">Hosting</span>
            <span className="ed-spec-val">SuperPossible</span>
          </div>
          <div className="ed-spec-row">
            <span className="ed-spec-key">Source</span>
            <span className="ed-spec-val">Saved to the SuperPossible repository</span>
          </div>
        </div>

        <div>
          <span className="ed-label" style={{ display: 'block', marginBottom: 8 }}>
            Live URL
          </span>
          <div className="ed-url-row">
            <input aria-label="Prototype URL" type="text" value={url} readOnly {...noAutofill} />
            <button type="button" className="ed-btn" onClick={handleCopyUrl}>
              {copied ? <Check size={15} /> : <Copy size={15} />}
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>
        </div>

        <div className="ed-actions">
          <a
            className="ed-btn ed-btn--primary ed-btn--lg"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open prototype
            <ArrowRight size={15} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AppBuilderQRCodeDisplay;
